import { Tab, TabProps } from '@mui/material';
import { Link } from 'components/common/Link';
import { StringHelper } from 'helpers/StringHelper';
import { useHtmlParser } from 'hooks/useHtmlParser';
import { forwardRef } from 'react';
import { colors } from 'styles/theme/colors';

type LevelOneTabProps = {
    slug: string;
    title: string;
    href?: string;
    index?: number;
    color?: string;
    action?: () => void;
};

export const LevelOneTab = forwardRef<HTMLDivElement, LevelOneTabProps>((props, ref) => {
    const {
        slug,
        title,
        href,
        index,
        color = colors.black,
        action,
    } = props;
    const lowercaseTitle = title.toLocaleLowerCase();
    const { parseHtml } = useHtmlParser();
    const parsedTitle = parseHtml(lowercaseTitle);
    const realSlug = StringHelper.uriToSlug(slug);

    const tabProps: TabProps & { 'data-testid': string } = {
        title: parsedTitle,
        onMouseEnter: () => action?.(),
        onFocus: () => action?.(),
        onClick: () => action?.(),
        sx: {
            textTransform: 'capitalize',
            padding: 3,
            fontSize: '16px',
            color,
        },
        'data-testid': `menu-item-${realSlug}`,
        label: parsedTitle,
        value: index,
        tabIndex: 0,
        ref,
    };

    if (!href) {
        return (
            <Tab {...tabProps} />
        );
    }

    return (
        <Link
            href={href ?? ''}
            tabIndex={-1}
        >
            <Tab {...tabProps} />
        </Link>
    );
});
